module.exports = __webpack_public_path__ + "media/components/images/panels/3-a-ad0f2d2ec42b9c355a7e16dbc09605df.jpeg";